import { PostIndexProps } from "./PostIndex";
import PostIndexList from "./PostIndexList";

function PostIndexDesktop({ indexList }: PostIndexProps) {
  return (
    <div className="absolute left-full top-0 hidden h-full w-72 post:block">
      <ul className="sticky top-36 ml-10 flex flex-col gap-3 border-l-2 border-lightgray px-4 py-1">
        <PostIndexList indexList={indexList} />
      </ul>
    </div>
  );
}

export default PostIndexDesktop;
